
import { Vue } from "vue-class-component";

export default class UserInfo extends Vue {}
